import React, { lazy } from 'react';
import { Route } from 'react-router';
import Authenticated from '../../components/auth/Authenticated';
import NotAuthenticated from '../../components/auth/NotAuthenticated';
import routes from '../routes';

const CustomerLoginScreen = lazy(() => import('../../screens/Auth/screens/Login'));
const HomeScreen = lazy(() => import('../../screens/Home/HomeScreen'));

const generalRoutes = [
    <Route
        exact
        key={routes.LOGIN}
        path={routes.LOGIN}
        render={() => (
            <NotAuthenticated redirectTo={routes.HOME}>
                <CustomerLoginScreen />
            </NotAuthenticated>
        )}
    />,

    <Route
        exact
        key={routes.HOME}
        path={routes.HOME}
        render={() => (
            <Authenticated>
                <HomeScreen />
            </Authenticated>
        )}
    />,
];

export default generalRoutes;
